import { InjectionToken, Provider } from '@angular/core';
import { ActionReducerMap } from '@ngrx/store';
import { SnackbarState } from '../snackbar-state';
import { initialState as initialSnackbarState, reducer as snackbarReducer } from './snackbar.reducer';

export const initialState: SnackbarState = initialSnackbarState;

export function getReducers(): ActionReducerMap<typeof snackbarReducer> {
  return snackbarReducer;
}

export const reducerToken: InjectionToken<ActionReducerMap<SnackbarState>> = new InjectionToken<
  ActionReducerMap<SnackbarState>
>('SnackbarReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
